import React, { useState } from 'react';
import {
    Box,
    Collapse,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton
} from '@mui/material';
import { KeyboardArrowRight, KeyboardArrowDown } from '@mui/icons-material';

const Constants = require("../../../constants/Constants");
let MAPS = Constants.MAPS;
let IMAGE_URL = Constants.IMAGE_URL;

const PlayerCourses = ({ courseData }) => {
    const [expandedCourse, setExpandedCourse] = useState(null);
    const [loadedImages, setLoadedImages] = useState({});

    // Toggle row expansion
    const handleRowClick = (courseId) => {
        setExpandedCourse(expandedCourse === courseId ? null : courseId);
    };

    // Function to get image URL, only when it's needed
    const getCourseImageUrl = (cupId, courseId, course) => {
        if (loadedImages[courseId]) return loadedImages[courseId];

        const imageUrl = `${IMAGE_URL}${MAPS[cupId - 1]?.races[(courseId - 1) % 4]?.mapImage}`;
        setLoadedImages(prevState => ({
            ...prevState,
            [courseId]: imageUrl,
        }));

        return imageUrl;
    };

    return (
        <Box sx={{ maxWidth: '90vw', display: 'flex', alignItems: 'center', justifyContent: 'center', width: "400px" }}>
            <Paper sx={{ maxWidth: '90vw', mb: 2, overflow: 'hidden', width: "400px" }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#4A4A4A', color: 'white' }}>Course</TableCell>
                                <TableCell sx={{ backgroundColor: '#4A4A4A', color: 'white' }}>APN</TableCell>
                                <TableCell sx={{ backgroundColor: '#4A4A4A', color: 'white' }}>Win Percent</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {courseData.map((course) => (
                                <React.Fragment key={course.courseId}>
                                    <TableRow
                                        hover
                                        onClick={() => handleRowClick(course.courseId)}
                                        sx={{
                                            cursor: 'pointer',
                                            backgroundColor: '#f5f5f5',
                                            '&:hover': { backgroundColor: '#e0e0e0' },
                                        }}
                                    >
                                        {/* Course Name + Expand/Collapse Arrow */}
                                        <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <IconButton
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Prevent row click from triggering
                                                        handleRowClick(course.courseId);
                                                    }}
                                                    size="small"
                                                >
                                                    {expandedCourse === course.courseId ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                                                </IconButton>
                                                <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{course.course}</Box>
                                            </Box>
                                        </TableCell>
                                        <TableCell>{course.apn}</TableCell>
                                        <TableCell>{course.winPercent}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={3} sx={{ padding: 0 }}>
                                            <Collapse in={expandedCourse === course.courseId} timeout="auto" unmountOnExit>
                                                <Box sx={{ padding: 2 }}>
                                                    {/* Course Image */}
                                                    <Box sx={{ textAlign: 'center', marginBottom: 2 }}>
                                                        <img
                                                            src={getCourseImageUrl(course.cupId, course.courseId, course.course)}
                                                            alt={`${course.course}`}
                                                            style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                                                        />
                                                    </Box>

                                                    {/* Course Stats Table */}
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>Race Count</TableCell>
                                                                <TableCell>{course.raceCount}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Win Count</TableCell>
                                                                <TableCell>{course.winCount}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Loss Count</TableCell>
                                                                <TableCell>{course.lossCount}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Firsts</TableCell>
                                                                <TableCell>{course.firsts}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Seconds</TableCell>
                                                                <TableCell>{course.seconds}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Thirds</TableCell>
                                                                <TableCell>{course.thirds}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Fourths</TableCell>
                                                                <TableCell>{course.fourths}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Lasts</TableCell>
                                                                <TableCell>{course.lasts}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Relative Win Percent</TableCell>
                                                                <TableCell>{course.relativeWinPercent}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>Relative Loss Count</TableCell>
                                                                <TableCell>{course.relativeLossCount}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};

export default PlayerCourses;
